import { AbstractCommand } from 'src/models/command';

const MEMORIZED_SEND_STATE = 2;
const DEFAULT_SEND_STATE = 3;

class SendNewMessage extends AbstractCommand {
	readonly name = 'IFS_Message_Compose_Command_Commands_SendMessage';

	public constructor(aggregateId: string, addressee: string, message: string, memorize: boolean = false) {
		super();
		this.parameters = {
			addressee: addressee,
			aggregateId: aggregateId,
			message: message,
			sendState: memorize ? MEMORIZED_SEND_STATE : DEFAULT_SEND_STATE,
			status: 1,
		};
	}
}

export { SendNewMessage };
